import React, { useState, useEffect } from 'react';
import { authService } from '../services/api';
import axios from 'axios';

function Users({ user }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [message, setMessage] = useState('');

  // Form state
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('manager');
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    try {
      const response = await axios.get('/api/users');
      setUsers(response.data);
    } catch (error) {
      console.error('Error loading users:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = () => {
    setEditingUser(null);
    setUsername('');
    setPassword('');
    setRole('manager');
    setIsActive(true);
    setShowModal(true);
  };

  const handleEdit = (u) => {
    setEditingUser(u);
    setUsername(u.username);
    setPassword('');
    setRole(u.role);
    setIsActive(u.is_active);
    setShowModal(true);
  };

  const handleDelete = async (userId) => {
    if (!window.confirm('Êtes-vous sûr de vouloir supprimer cet utilisateur ?')) {
      return;
    }

    try {
      await axios.delete(`/api/users/${userId}`);
      setMessage('Utilisateur supprimé');
      setTimeout(() => setMessage(''), 3000);
      loadUsers();
    } catch (error) {
      setMessage('Erreur lors de la suppression');
      setTimeout(() => setMessage(''), 3000);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();

    const data = {
      username,
      role,
      is_active: isActive
    };

    if (password) {
      data.password = password;
    }

    try {
      if (editingUser) {
        await axios.put(`/api/users/${editingUser.id}`, data);
        setMessage('Utilisateur modifié');
      } else {
        await axios.post('/api/users', { ...data, password });
        setMessage('Utilisateur créé');
      }
      setTimeout(() => setMessage(''), 3000);
      setShowModal(false);
      loadUsers();
    } catch (error) {
      setMessage('' + (error.response?.data?.error || 'Erreur'));
      setTimeout(() => setMessage(''), 3000);
    }
  };

  if (user.role !== 'admin') {
    return (
      <div className="page">
        <h1>Utilisateurs</h1>
        <p>Accès réservé aux administrateurs.</p>
      </div>
    );
  }

  if (loading) {
    return <div className="loading">Chargement...</div>;
  }

  return (
    <div className="users-page">
      <div className="page-header">
        <h1>Gestion des utilisateurs</h1>
        <button onClick={handleCreate} className="btn-secondary">
          Créer un utilisateur
        </button>
      </div>

      {message && <div className="message-banner">{message}</div>}

      <div className="users-table">
        <table>
          <thead>
            <tr>
              <th>Utilisateur</th>
              <th>Rôle</th>
              <th>Statut</th>
              <th>Créé le</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map(u => (
              <tr key={u.id}>
                <td className="user-cell">
                  <strong>{u.username}</strong>
                </td>
                <td>
                  <span className={`role-badge ${u.role}`}>
                    {u.role === 'admin' ? '👑 Admin' : '👔 Manager'}
                  </span>
                </td>
                <td>
                  <span className={`status-badge ${u.is_active ? 'active' : 'inactive'}`}>
                    {u.is_active ? 'Actif' : '⛔ Inactif'}
                  </span>
                </td>
                <td>{new Date(u.created_at).toLocaleDateString('fr-FR')}</td>
                <td className="actions-cell">
                  <button onClick={() => handleEdit(u)} className="btn-icon" title="Modifier">
                    ✏️
                  </button>
                  {u.id !== user.id && (
                    <button onClick={() => handleDelete(u.id)} className="btn-icon btn-delete-icon" title="Supprimer">
                      🗑️
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editingUser ? 'Modifier l\'utilisateur' : 'Créer un utilisateur'}</h2>
              <button onClick={() => setShowModal(false)} className="btn-close">✕</button>
            </div>

            <form onSubmit={handleSave}>
              <div className="form-group">
                <label>Nom d'utilisateur *</label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Ex: john.doe"
                  required
                  autoFocus
                />
              </div>

              <div className="form-group">
                <label>Mot de passe {editingUser ? '(laisser vide pour ne pas changer)' : '*'}</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Mot de passe"
                  required={!editingUser}
                />
              </div>

              <div className="form-group">
                <label>Rôle *</label>
                <select value={role} onChange={(e) => setRole(e.target.value)} required>
                  <option value="manager">👔 Manager</option>
                  <option value="admin">👑 Admin</option>
                </select>
                <p className="help-text">
                  Manager: Gestion écrans, groupes, playlists.<br/>
                  Admin: Accès complet + gestion utilisateurs.
                </p>
              </div>

              <div className="form-group checkbox">
                <label>
                  <input
                    type="checkbox"
                    checked={isActive}
                    onChange={(e) => setIsActive(e.target.checked)}
                  />
                  <span>Utilisateur actif</span>
                </label>
              </div>

              <div className="modal-actions">
                <button type="button" onClick={() => setShowModal(false)} className="btn-secondary">
                  Annuler
                </button>
                <button type="submit" className="btn-secondary">
                  {editingUser ? 'Modifier' : 'Créer'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Users;
